var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['v-ribbon', `v-ribbon--${_vm.position}`]},[_c('div',{class:['v-ribbon__wrapper']},[_c('div',{class:[
        'v-ribbon__wrapper__rotate',
        'font-weight-bold',
        `bg-${_vm.color}`
      ]},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }